import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withStyles } from '@material-ui/core/styles/index';
import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem'
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import PropTypes from 'prop-types';


const styles = theme => ({
    formLabel: {
        zIndex: 2,
        backgroundColor: '#fff',
    },
    formControl: {
        margin: `${theme.spacing.unit}px 0`,
        width: '100%',
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: theme.spacing.unit / 4,
        marginTop: '-.4rem',
        marginBottom: '-.4rem',
    },
});


class SelectControl extends Component {
    handleChange = (e) => {
        const { multiple, onChange, options } = this.props;
        let value = e.target.value;
        if (multiple) {
            if (value.indexOf('') > -1) {
                value = options.map(option => option.value);
            }
        }
        onChange(e, value);
    }

    render() {
        const { classes, className, error, value = '', options, onChange, variant='outlined', InputLabelProps, label, required = true, blankLabel = 'All', multiple = false, ...other } = this.props;
        return (
            <FormControl variant={variant} className={classes.formControl} error={error}>
                <InputLabel className={classes.formLabel}
                    ref={ref => {
                        this.labelRef = ReactDOM.findDOMNode(ref);
                    }}
                    {...InputLabelProps}
                >
                    {label}
                </InputLabel>
                <Select
                    multiple={multiple}
                    onChange={this.handleChange}
                    value={value === '' && multiple ? [] : value}
                    input={variant === 'outlined' ? <OutlinedInput className={className} labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0} /> : <Input disableUnderline={true}/>}
                    renderValue={multiple ? (selected => (
                        <div className={classes.chips}>
                            {selected.length === options.length 
                            ? <Chip key='all' label='All' className={classes.chip} /> 
                            : selected.map(value => <Chip key={value} label={value} className={classes.chip} />)
                            }
                        </div>
                    )) : null}
                    {...other}
                >
                    {!required && <MenuItem value=''><em>{blankLabel}</em></MenuItem>}
                    {options.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                </Select>
            </FormControl>
        );
    }
}

SelectControl.propTypes = {
    classes: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    multiple: PropTypes.bool,
    blankLabel: PropTypes.string,

};

export default withStyles(styles)(SelectControl);
